import React from 'react';
import { RiskManagement, AssetDetails, InspectionDetails } from '.';
import { addRouteNamespace } from '@Utils/actions';
import { getRiskTabIndex } from '@Utils/riskTabOrder';
import RiskManagementList from './RiskManagementList';

// NOTE WE DONT NEED TO TRANSLATE THESE AS MOST ARE NEVER SHOWN
export const getMainPageRoutes = (isRiskTemplatesEnabled: boolean) => [
	{
		title: 'Results',
		to: addRouteNamespace('results/:configId'),
		render: (
			<RiskManagement
				page={getRiskTabIndex('results', isRiskTemplatesEnabled)}
			/>
		),
	},
	{
		title: 'Likelihood of Failure Setup',
		to: addRouteNamespace('lofSetup/:configId'),
		render: (
			<RiskManagement
				page={getRiskTabIndex('lofSetup', isRiskTemplatesEnabled)}
			/>
		),
	},
	{
		title: 'Consequence of Failure Setup',
		to: addRouteNamespace('cofSetup/:configId'),
		render: (
			<RiskManagement
				page={getRiskTabIndex('cofSetup', isRiskTemplatesEnabled)}
			/>
		),
	},
	{
		title: 'Risk Setup',
		to: addRouteNamespace('riskSetup/:configId'),
		render: (
			<RiskManagement
				page={getRiskTabIndex('riskSetup', isRiskTemplatesEnabled)}
			/>
		),
	},
	{
		title: 'Risk Log',
		to: addRouteNamespace('riskLog/:configId'),
		render: (
			<RiskManagement
				page={getRiskTabIndex('riskLog', isRiskTemplatesEnabled)}
			/>
		),
	},
	{
		title: 'Asset Details',
		to: addRouteNamespace('riskAssetDetails/:assetId'),
		render: <AssetDetails />,
	},
	{
		title: 'Inspection Details',
		to: addRouteNamespace('riskInspectionDetails/:standard/:inspectionId'),
		render: <InspectionDetails />,
	},
];

export const getMiniPageRoutes = (isRiskTemplatesEnabled: boolean) => [
	{
		title: 'Risk',
		to: '/risk',
		icon: <img src={require('./repo-icon.svg')} alt="risk" />,
		render: <RiskManagement />,
	},
	...getMainPageRoutes(isRiskTemplatesEnabled),
];

export const getMiniPageRoutesMulti = (isRiskTemplatesEnabled: boolean) => [
	{
		title: 'Risk',
		to: '/risk',
		icon: <img src={require('./repo-icon.svg')} alt="risk" />,
		render: <RiskManagementList />,
	},
	...getMainPageRoutes(isRiskTemplatesEnabled),
];
